query GetCompetitors {
    competitors(first: 1000) {
        edges {
            node {
                id
                name
            }
        }
    }
}
